<template>
  <a-modal
    title="编辑草药信息表"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['medicineid']" /></a-form-item>
        <a-form-item
          label="中药编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入中药编码" v-decorator="['medicinecode', {rules: [{required: true, message: '请输入中药编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="中药名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入中药名称" v-decorator="['medicinename', {rules: [{required: true, message: '请输入中药名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="拼音简写"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入拼音简写" v-decorator="['pinyin']" />
        </a-form-item>
        <a-form-item
          label="规格"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入规格" v-decorator="['specification', {rules: [{required: true, message: '请输入规格！'}]}]" />
        </a-form-item>
        <a-form-item
          label="分类名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-select placeholder="请输入分类名称" :options="hmSortnameList" show-search  :filter-option="filterOption2" v-decorator="['hmSortcode']" label-in-value @change="handleChange1"></a-select>
        </a-form-item>
        <a-form-item
          label="剂型名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
         <a-select placeholder="请输入剂型名称" :options="dosenameList" show-search  :filter-option="filterOption1" v-decorator="['doseid', {rules: [{required: true, message: '请输入剂型名称！'}]}]" label-in-value  @change="handleChange2"></a-select>
        </a-form-item>
        <a-form-item
          label="生产商名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请输入生产商名称" :options="manunameList" show-search  :filter-option="filterOption3" v-decorator="['manuid']"  label-in-value  @change="handleChange3"></a-select>
        </a-form-item>
        <a-form-item
          label="有效期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择有效期" v-decorator="['validDate']" @change="onChangevalidDate"/>
        </a-form-item>
        <a-form-item
          label="单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入单位" v-decorator="['baseUnit', {rules: [{required: true, message: '请输入单位！'}]}]" />
        </a-form-item>
        <a-form-item
          label="剂量单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入剂量单位" v-decorator="['mediUnit']" />
        </a-form-item>
        <a-form-item
          label="最小包装单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入最小包装单位" v-decorator="['packageUnitid']" />
        </a-form-item>
        <a-form-item
          label="最小包装单位名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入最小包装单位名称" v-decorator="['packageUnit']" />
        </a-form-item>
        <a-form-item
          label="最小包装单位转换系数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入最小包装单位转换系数" v-decorator="['packageFactor']" />
        </a-form-item>
        <a-form-item
          label="单价"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入单价" v-decorator="['unitprice', {rules: [{required: true, message: '请输入单价！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医保备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入医保备注" v-decorator="['medinsrem']" />
        </a-form-item>
        <a-form-item
          label="精品中药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择精品中药" :options="fineflagList" show-search  :filter-option="filterOption4" v-decorator="['fineflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="医保等级"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入医保等级" v-decorator="['medinslevel']" />
        </a-form-item>
        <a-form-item
          label="使用标记"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择使用标记" :options="useflagList" show-search  :filter-option="filterOption5" v-decorator="['useflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入备注" v-decorator="['remarks']" />
        </a-form-item>
        <a-form-item
          label="用药途径"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入用药途径" v-decorator="['extend1']" />
        </a-form-item>
        <a-form-item
          label="频次名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入频次名称" v-decorator="['extend2']" />
        </a-form-item>
        <a-form-item
          label="来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择来源" :options="channelList" show-search  :filter-option="filterOption6" v-decorator="['channel']"></a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { baHerbalMedicineEdit, baDatadictDetailList } from '@/api/modular/interhospital/baherbalmedicine/baHerbalMedicineManage'
  import moment from 'moment'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        visible: false,
        validDateDateString: '',
        confirmLoading: false,
        form: this.$form.createForm(this),
        dosenameList: [],
        datadictDetailList: [],
        manunameList: [],
        fineflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        useflagList:  [
          {
            label:'未使用',
            value: '0'
          },
          {
            label:'使用',
            value: '1'
          },
        ],
        channelList:  [
          {
            label:'his',
            value: 0
          },
          {
            label:'管理后台',
            value: 1
          },
        ],
        hmSortnameList: [],
        dosenameList: [],
        manunameList: [],
        getselectValue: {},
        record: {},
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        this.getDosenameList()
        this.gethmSortnameList()
        this.getManunameList()
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              medicineid: record.medicineid,
              medicinecode: record.medicinecode,
              medicinename: record.medicinename,
              pinyin: record.pinyin,
              specification: record.specification,
              dosename: record.dosename,
              manuname: record.manuname,
              baseUnit: record.baseUnit,
              mediUnit: record.mediUnit,
              packageUnitid: record.packageUnitid,
              packageUnit: record.packageUnit,
              unitprice: record.unitprice,
              packageFactor: record.packageFactor,
              hmSortcode: {'key':record.hmSortcode, 'label': record.hmSortname },
              hmSortname: record.hmSortname,
              doseid: {'key':record.doseid, 'label': record.dosename },
              manuid: {'key':record.manuid, 'label': record.manuname },
              validDate: record.validDate,
              medinsrem: record.medinsrem,
              fineflag: record.fineflag,
              medinslevel: record.medinslevel,
              useflag: record.useflag,
              remarks: record.remarks,
              extend1: record.extend1,
              extend2: record.extend2,
              channel: record.channel
              
            }
          )
          this.record = record
        }, 100)
        // 时间单独处理
        if (record.validDate != null) {
           this.form.getFieldDecorator('validDate', { initialValue: moment(record.validDate, 'YYYY-MM-DD') })
        }
        this.validDateDateString = moment(record.validDate).format('YYYY-MM-DD')
      },
      handleChange1(value){
        const { label, key } = value;
        this.getselectValue.hmSortname = label
        this.getselectValue.hmSortcode = key
      },
      handleChange2(value){
        const { label, key } = value;
        this.getselectValue.dosename = label
        this.getselectValue.doseid = key
      },
      handleChange3(value){
        const { label, key } = value;
        this.getselectValue.manuname = label
        this.getselectValue.manuid = key
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.validDate = this.validDateDateString
            if(!this.getselectValue.hmSortcode){
              this.getselectValue.hmSortname = this.record.hmSortname;
              this.getselectValue.hmSortcode = this.record.hmSortcode;
            }
            if(!this.getselectValue.doseid){
              this.getselectValue.dosename = this.record.dosename;
              this.getselectValue.doseid = this.record.doseid;
            }
            if(!this.getselectValue.manuid){
              this.getselectValue.manuname = this.record.manuname;
              this.getselectValue.manuid = this.record.manuid;
            }
            baHerbalMedicineEdit(Object.assign(values,this.getselectValue)).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangevalidDate(date, dateString) {
        this.validDateDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      },
      getDosenameList() {
        baDatadictDetailList({
          dictId: 26
        }).then(res => {
          if (res.code == 200) {
            this.dosenameList = [];
            res.data.map(item => {
              this.dosenameList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getManunameList() {
        baDatadictDetailList({
          dictId: 17
        }).then(res => {
          if (res.code == 200) {
            this.manunameList = [];
            res.data.map(item => {
              this.manunameList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      gethmSortnameList() {
        baDatadictDetailList({
          dictId: 22
        }).then(res => {
          if (res.code == 200) {
            this.hmSortnameList = [];
            res.data.map(item => {
              this.hmSortnameList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      filterOption1(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption2(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption3(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption4(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption5(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption6(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>
<style lang="less" scoped>

/deep/ .ant-form-item-label{
  text-overflow: ellipsis;
}

.ant-calendar-picker-container{
  z-index: 2000;
}
</style>
